import { render, staticRenderFns } from "./PFContributionChart.vue?vue&type=template&id=01b311e6"
import script from "./PFContributionChart.vue?vue&type=script&lang=js"
export * from "./PFContributionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports